import { useAuthStore } from "@/features/auth";
import { ChatComponent } from "@/features/chat/ui";
import { connectWS, getSocket } from "@/processes/socket";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const user = useAuthStore((s) => s.user);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && user?._id) {
      connectWS(token, user._id, navigate);

      return () => {
        getSocket()?.disconnect();
      };
    }
  }, [user?._id]);

  return (
    <div style={{ position: "relative", padding: 12, height: "100%" }}>
      <ChatComponent />
    </div>
  );
}
